import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class CamionSucursalService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerCamionSucursalxRutEmpresaSucursal(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($rut_empresa: Decimal, $sucursal_codigo: Decimal, $tipobusqueda: Int) {
          camion_sucursal {
            obtenerCamionSucursalxRutEmpresaSucursal(rut_empresa: $rut_empresa, sucursal_codigo: $sucursal_codigo, tipobusqueda: $tipobusqueda) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  patente
                  descripcion
                  volumen
                  peso_maximo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.camion_sucursal.obtenerCamionSucursalxRutEmpresaSucursal;
            // Asegurar que respuesta tenga registros válidos
            if (respuesta && !respuesta.registros) {
                respuesta.registros = [];
            }
            callback({ mensajes, respuesta });
        });
    }
}
CamionSucursalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CamionSucursalService_Factory() { return new CamionSucursalService(i0.ɵɵinject(i1.GraphQLClient)); }, token: CamionSucursalService, providedIn: "root" });
